<div class="tree-node-content" [class.selected]="node().isFocused" [title]="node().name" #content
  (click)="nodeClicked.emit(node().lineId)"
  (contextmenu)="nodeMenuRequested.emit({ lineId: node().lineId, event: $event })">
  @if (depthLevel() > 0) {
    <div class="tree-node-horizontal-connector"></div>
  }

  <div class="tree-node-name">{{ node().name }}</div>

  <div class="tree-node-amount">{{ formatAmount(node().amount, node().unit) }}</div>

  <!-- always rendered, so the amounts line up whether or not the line has a marker -->
  <div class="tree-node-marker">{{ node().marker }}</div>
</div>

<div class="tree-node-children">
  @for (child of node().children; track child.lineId) {
    <context-tree-node [node]="child" [depthLevel]="depthLevel() + 1"
      (nodeClicked)="nodeClicked.emit($event)"
      (nodeMenuRequested)="nodeMenuRequested.emit($event)"></context-tree-node>
  }
</div>
